/** Shared open state so sidebar + profile can open one Grant Access modal. */
export const grantAccessModal = $state({
  open: false,
  serverUid: '' as string,
  serverName: '' as string,
})

export function openGrantAccess(serverUid: string, serverName = '') {
  grantAccessModal.serverUid = serverUid
  grantAccessModal.serverName = serverName
  grantAccessModal.open = true
}
